import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  gross_method_rate: {
    name: 'As calculated under the Gross Method',
    order: 233,
    letter: 'A'
  },
  commitment_method_rate: {
    name: 'As calculated under the Commitment Method',
    order: 234,
    letter: 'A'
  }
};

export function Leverage({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.LEVERAGE_AIF,
    onChangeFund,
    schema: schema.LEVERAGE_AIF,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.LEVERAGE_AIF?.field_names || [],
    columnLables,
    tableName: 'LEVERAGE_AIF',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="fca-reporttables-leverage-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
